import { takeEvery, call, put, select, getContext } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import { tracked } from '../../utils/sagaWrappers';
import { actions, HIDE_AUTH_MODAL, TOKENS_REMOVE } from '../../actions/app';
import { currentUserId } from '../../selectors/app';
import { ACTIVATE, DEACTIVATE, lifecycle } from './actions';
import { Props } from '.';
import { Services } from 'init/services';
import { SagaContext } from '../../types/common';

export default tracked<Props>(
  function* saga(action: ReturnType<typeof lifecycle.activate>) {
    const keycloakService: Services[SagaContext.KeycloakService] = yield getContext(
      SagaContext.KeycloakService
    );

    let tokens: ReturnType<typeof keycloakService.getTokens> | undefined;
    try {
      tokens = yield call([keycloakService, 'getTokens']);
    } catch (e) {}

    const { backTo, scope, pathname, needRefresh } = action.payload;

    if (!tokens && (!scope || pathname.startsWith(scope))) {
      yield put(actions.showAuthModal('signin', 'mainMenu', 'desktopMainMenuRegistration'));
    }

    yield takeEvery([HIDE_AUTH_MODAL, TOKENS_REMOVE], function* () {
      const userId: ReturnType<typeof currentUserId> = yield select(currentUserId);
      if (!userId && backTo) {
        if (needRefresh) {
          window.location.href = backTo;
          return;
        }
        yield put(push(backTo));
      }
    });
  },
  ACTIVATE,
  DEACTIVATE
);
